import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const EmailQuote = {
  Content: lazy(
    () =>
      import('components/direct-sales/email-quote/components/EmailQuoteContent')
  )
};

export default EmailQuote;
